var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isFull)?_c('div',{key:"move_cont",staticClass:"fixed right-12 bottom-28 left-auto top-auto bg-666 move_video z-50",style:({
    width: '100%',
    height:'100%',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0
  })},[_c('i',{staticClass:"el-icon-close text-medium-x text-white absolute top-3 right-3 z-10 cursor-pointer",on:{"click":_vm.closeHandle}}),_c('video-player',{ref:"video",attrs:{"options":_vm.options}})],1):_c('div',{directives:[{name:"move",rawName:"v-move"}],key:"static_cont",staticClass:"fixed right-12 bottom-28 left-auto top-auto bg-666 move_video z-50",style:({
    width: _vm.options.width,
    height: _vm.options.height,
    left: null,
    top: null,
    right: null,
    bottom: null
  })},[_c('i',{staticClass:"el-icon-close text-medium-x text-white absolute top-3 right-3 z-10 cursor-pointer",on:{"click":_vm.closeHandle}}),_c('video-player',{ref:"video",attrs:{"options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }